<template>
    <Page header="Партнер">
        <template v-slot:body>
            <Tabs v-model:value="active">
                <TabList>
                    <Tab :value="0">
                        <span class="font-medium text-sm xl:text-base lg:text-base">Данные</span>
                    </Tab>
                    <Tab :value="1">
                        <span class="font-medium text-sm xl:text-base lg:text-base">Пользователи</span>
                    </Tab>
                    <Tab :value="2">
                        <span class="font-medium text-sm xl:text-base lg:text-base">Переводы</span>
                    </Tab>
                </TabList>
                <TabPanels>
                    <TabPanel :value="0">
                        <div v-if="partner" class="w-full flex flex-column gap-3" >

                            <MobMenu :items="[]" colorType="gray" class="w-full max-w-30rem">
                                <template v-slot:body>
                                    <div v-if="partner.user && partner.user.id" class="w-full flex flex-row px-3 py-2 border-0 border-bottom-1" 
                                        style="min-height:50px" @click="toDetail(partner.user.id, 'user')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Пользователь</span>
                                        </div>
                                        <div v-if="partner.user.name" class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ partner.user.name }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" />
                                        </div>
                                    </div>
                                    <div v-if="partner.wallet && partner.wallet.id" class="w-full flex flex-row px-3 py-2 border-0 border-bottom-1" 
                                        style="min-height:50px" @click="toDetail(partner.wallet.id, 'wallet')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Кошелек</span>
                                        </div>
                                        <div v-if="partner.wallet.type" class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ partner.wallet.type }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" />
                                        </div>
                                    </div>
                                </template>
                            </MobMenu>

                            <div class="w-full flex flex-column gap-2 relative surface-100 border-round-xl xl:border-round-2xl p-3 xl:p-4">
                                <span class="flex gap-3 text-lg xl:text-xl text-900 font-medium">
                                    Пользователь: 
                                </span>
                                <span class="flex flex-column gap-2 text-sm xl:text-base text-600">
                                    <span v-if="partner.user.id" class="flex">ID: {{ partner.user.id }}</span>
                                    <span v-if="partner.user.name" class="flex">Имя: {{ partner.user.name }}</span>
                                    <span v-if="partner.user" class="flex">Логин: {{ partner.user.login }}</span>
                                </span>
                            </div>

                            <div class="w-full flex flex-column gap-2 relative surface-100 border-round-xl xl:border-round-2xl p-3 xl:p-4">
                                <span class="flex gap-3 text-lg xl:text-xl text-900 font-medium">
                                    Статистика: 
                                </span>
                                <span class="flex flex-column gap-2 text-sm xl:text-base text-600">
                                    <span v-if="partner.count" class="flex">Переводов: {{ partner.count.transfers }}</span>
                                    <span v-if="partner.count" class="flex">Пользователей: {{ partner.count.users }}</span>
                                </span>
                            </div>

                            <div v-if="partner.wallet" class="w-full flex flex-column gap-2 relative surface-100 border-round-xl xl:border-round-2xl p-3 xl:p-4">
                                <span class="flex gap-3 text-lg xl:text-xl text-900 font-medium">
                                    Кошелек: 
                                </span>
                                <span class="flex flex-column gap-2 text-sm xl:text-base text-600">
                                    <span v-if="partner.wallet.id" class="flex">ID: {{ partner.wallet.id }}</span>
                                    <span v-if="partner.wallet.balance" class="flex">Баланс: {{ get_format_amount(partner.wallet.balance.$numberDecimal, partner.wallet.currency) }}</span>
                                    <span v-if="partner.wallet.type" class="flex">Тип: {{ partner.wallet.type }}</span>
                                </span>
                            </div>
                            <!-- <div v-else>
                                <span>нет кошелька</span><br>
                                <Button v-if="isUserInGroup('admin')" label="Создать кошель" @click="create_wallet()" class="mt-2"/>
                            </div> -->
                        </div>
                        <Skeleton v-else height="2rem" />
                    </TabPanel>

                    <TabPanel :value="1">
                        <div v-if="users && users.length>0">
                            <DataTable v-if='users' :value="users" responsiveLayout="scroll"
                                lazy paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50, 100]" :totalRecords="totalUsers"
                                @page="onPageUser($event)" @sort="onSortUser($event)" :loading="loadingUsers">

                                <Column field="_id" >
                                    <template #header>
                                        <span class="text-xs font-medium">ID</span>
                                    </template>
                                    <template #body="{ data }">
                                        <span class="text-sm flex flex-row" @click="copy(data.id)">
                                            <span class="flex">{{get_short_id(data.id)}}</span>
                                            <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                                        </span>
                                    </template>
                                </Column>

                                <Column field="_id" filterMatchMode="startsWith" :exportable="false">
                                    <template #header>
                                        <span class="text-xs font-medium">Польз.</span>
                                    </template>
                                    <template #body="{ data }">
                                        <div class="flex flex-row align-items-center gap-2">
                                            <AvatarGroup v-if="data.telegram && data.telegram.photo_url" class="flex">
                                                <Avatar :image="data.telegram.photo_url" shape="circle" />
                                            </AvatarGroup>
                                            <AvatarGroup v-else class="flex">
                                                <Avatar icon="pi pi-user" shape="circle" />
                                            </AvatarGroup>
                                            <span @click="go_to_user(data.id)" class="flex gap-2 text-xs white-space-nowrap cursor-pointer">
                                                {{ data.name }} <span class="pi pi-external-link text-xs flex"></span>
                                            </span>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="login">
                                    <template #header>
                                        <span class="text-xs font-medium">Логин</span>
                                    </template>
                                    <template #body="{ data }">
                                        <span class="text-sm flex flex-row">
                                            {{ data.login }}
                                        </span>
                                    </template>
                                </Column>

                                <Column field="date_created">
                                    <template #header>
                                        <span class="text-xs font-medium">Дата регистрации</span>
                                    </template>
                                    <template #body="{ data }">
                                        <span class="text-sm flex flex-row">
                                            {{ formatDate(data.date_created) }}
                                        </span>
                                    </template>
                                </Column>

                                <template #footer>
                                    Всего {{ totalUsers }} записей. 
                                </template>

                            </DataTable>
                        </div>
                        <div v-else-if="users && users.length==0">
                            <span class="text-sm">Пользователи не найдены</span>
                        </div>
                        <Skeleton height="2rem" v-else />
                    </TabPanel>

                    <TabPanel :value="2">
                        <div v-if="transfers && transfers.length>0">
                            <DataTable v-if='transfers' :value="transfers" class="mt-3" responsiveLayout="scroll"
                                lazy paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50, 100]" :totalRecords="totalTransfers"
                                @page="onPageTrans($event)" @sort="onSortTrans($event)" :loading="loadingTransfers">

                                <Column field="_id">
                                    <template #header>
                                        <span class="text-xs font-medium">ID</span>
                                    </template>
                                    <template #body="{ data }">
                                        <span class="text-sm flex flex-row" @click="copy(data._id)">
                                            <span class="flex">{{get_short_id(data._id)}}</span>
                                            <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                                        </span>
                                    </template>
                                </Column>

                                <Column field="sender_amount.$numberDecimal" :footer="totalAmount" :exportable="false">
                                    <template #header>
                                        <span class="text-xs font-medium">Сумма&nbspотпр.</span>
                                    </template>
                                    <template #body="{ data }">
                                        <span class="text-sm">{{ get_format_amount(data.sender.amount.$numberDecimal, data.sender.currency_code) }}</span>
                                    </template>
                                </Column>

                                <Column field="recipient_amount.$numberDecimal" :exportable="false">
                                    <template #header>
                                        <span class="text-xs font-medium">Сумма&nbspполуч.</span>
                                    </template>
                                    <template #body="{ data }">
                                        <span class="text-sm">{{ get_format_amount(data.recipient.amount.$numberDecimal, data.recipient.currency_code) }}</span>
                                    </template>
                                </Column>

                                <Column field="status" :showFilterMenu="true" :showFilterMatchModes="false">
                                    <template #header>
                                        <span class="text-xs font-medium">Статус</span>
                                    </template>
                                    <template #body="{ data }">
                                        <div :class="'status-'+data.status" 
                                            class="inline-block py-1 px-2 text-xs border-round-md font-medium border-2 surface-border text-500 align-items-center" >
                                            <span class="flex">{{getStatusLabel(data.status)}}</span>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="partner_amount.$numberDecimal" :footer="get_format_amount(totalComission, 'usdt')" :exportable="false">
                                    <template #header>
                                        <span class="text-xs font-medium">Сумма&nbspвознагр.</span>
                                    </template>
                                    <template #body="{ data }">
                                        <span class="text-sm">{{ get_format_amount(data.partner.amount.$numberDecimal, 'usdt') }}</span>
                                    </template>
                                </Column>

                                <Column field="partner_payout" :showFilterMenu="false" :showFilterMatchModes="false">
                                    <template #header>
                                        <span class="text-xs font-medium">Выплата</span>
                                    </template>
                                    <template #body="{ data }">
                                        <Tag :severity="(data.partner.payout) ? 'success' : 'secondary'" :value="(data.partner.payout) ? 'Выплачен' : 'Нет'" />
                                    </template>
                                </Column>

                                <Column field="dates.created">
                                    <template #header>
                                        <span class="text-xs font-medium">Дата создания</span>
                                    </template>
                                    <template #body="{ data }">
                                        <span class="text-sm flex flex-row">
                                            {{ formatDate(data.dates.created) }}
                                        </span>
                                    </template>
                                </Column>

                                <Column field="_id">
                                    <template #body="slotProps">
                                        <Button label="Подробно" @click="toDetail(slotProps.data._id, 'transfer', true)" 
                                            size="small" icon="pi pi-external-link" icon-pos="right" severity="secondary"/>
                                    </template>
                                </Column>

                                <template #footer>
                                    Всего {{ totalTransfers }} записей
                                </template>


                            </DataTable>
                        </div>
                        <div v-else-if="transfers && transfers.length==0">
                            <span class="text-sm">Переводы не найдены</span>
                        </div>
                        <Skeleton height="2rem" v-else />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { useRoute } from 'vue-router'
import BigNumber from 'bignumber.js'
import Page from "@/components/sides/Page.vue"
import MobMenu from '@/components/sides/menu/MobMenu.vue'

export default {
    data() {
        return {
            partner: null,
            
            users: null,
            transfers: null,

            active: 0,
            lazyParams: {},

            totalUsers: 0,
            totalTransfers: 0,
            totalComission: 0,
            totalAmount: 0,

            loadingUsers: false,
            loadingTransfers: false,

            defaulParams: {
                first: 0,
                rows: 10,
                sortField: null,
                sortOrder: null,
                filters: null,
            },
        }
    },
    components: {
        Page,
        MobMenu
    },
    watch: {
        active: function (val) {
            if(val==1 && !this.users) {
                this.lazyParams = this.defaulParams
                this.loadUsers(this.partner.user.id)
            }
            if(val==2 && !this.transfers) {
                this.lazyParams = this.defaulParams
                this.loadTransfers(this.partner.user.id)
            }
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' }
    },
    methods: {
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        toDetail(id, type='user', new_tab = false) {
            if(new_tab){
                const routeData = this.$router.resolve({path: '/admin/'+type+'/' + id});
                window.open(routeData.href, '_blank');
            } else  this.$router.push({ path: '/admin/'+type+'/' + id })
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        get_short_id(value){
            if(!value) return ''
            return this.helper.get_short_id(value)
        },
        go_to_user(id){
            const go = this.$router.resolve({path: '/admin/user/' + id})
            window.open(go.href, '_blank')
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        getStatusLabel(status){
            return this.helper.get_severity_status(status, this.lang_)
        },
        async create_wallet(){
            const data = {
                user_id: this.partner.user.id,
                type: 'partner'
            }
            const res = await this.connect.create_wallet(data).then(res=>res)
            if(res.result){
                this.partner.wallet = res.data
                this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Кошелек создан', life: 4000 })
            } else {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: res.errors[0], life: 4000 })
            }
        },

        // USERS
        onPageUser(event) {
            this.lazyParams = event
            this.loadUsers(this.partner.user.id)
        },
        onSortUser(event) {
            this.lazyParams = event
            this.loadUsers(this.partner.user.id)
        },            
        // загрузка пользователей
        async loadUsers(id){
            this.loadingUsers = true
            window.scrollTo({ top: 0, behavior: 'smooth' })

            const limit = (this.lazyParams.rows) ? this.lazyParams.rows : 10
            const skip = (this.lazyParams.first) ? this.lazyParams.first : 0
            const filter = (this.lazyParams.filters) ? this.lazyParams.filters : {}

            let sort = {date_created: 1}
            if(this.lazyParams.sortField && this.lazyParams.sortOrder){
                sort = {}
                sort[this.lazyParams.sortField] = (this.lazyParams.sortOrder == 1) ? 1 : -1
            }

            const filter_ = {
                referrer: {
                    value: id,
                }
            }

            const filter_and = Object.assign(filter, filter_)

            const res = await this.connect.user_list(limit, skip, filter_and, sort).then(res=>res)
            if(res.result && res.data){
                this.users = res.data
                this.totalUsers = res.total
            }
            this.loadingUsers = false
        },
        
        // TRANSFERS
        onPageTrans(event) {
            this.lazyParams = event
            this.loadTransfers(this.partner.user.id)
        },
        onSortTrans(event) {
            this.lazyParams = event
            this.loadTransfers(this.partner.user.id)
        },
        // onFilterUser() {
        //     this.lazyParams.filters = this.filters
        //     this.loadUsers(this.partner.user.id)
        // },

        // загрузка переводов
        async loadTransfers(id){
            this.loadingTransfers = true
            window.scrollTo({ top: 0, behavior: 'smooth' })

            const limit = (this.lazyParams.rows) ? this.lazyParams.rows : 10
            const skip = (this.lazyParams.first) ? this.lazyParams.first : 0
            const filter = (this.lazyParams.filters) ? this.lazyParams.filters : {}

            const filter_ = {
                partner_id: {
                    value: id,
                },
                status: {
                    value: 'completed',
                }
            }

            const filter_and = Object.assign(filter, filter_)
            
            let sort = {'dates.created': -1}
            if(this.lazyParams.sortField && this.lazyParams.sortOrder){
                sort = {}
                sort[this.lazyParams.sortField] = (this.lazyParams.sortOrder == 1) ? 1 : -1
            }
            
            const res = await this.connect.transfers_list(limit, skip, filter_and, sort).then(res=>res)
            if(res.result && res.data){
                this.transfers = res.data
                this.totalTransfers = res.total

                this.totalComission = new BigNumber(0)
                this.totalAmount = new BigNumber(0)
                for(let i=0; i<res.data.length; i++){
                    let comission = new BigNumber(res.data[i].partner.amount.$numberDecimal)
                    this.totalComission = this.totalComission.plus(comission)

                    let amount = new BigNumber(res.data[i].sender.amount.$numberDecimal)
                    this.totalAmount = this.totalAmount.plus(amount)
                }
                if(this.totalComission.isNaN()){
                    this.totalComission = new BigNumber(0)
                }
                if(this.totalAmount.isNaN()){
                    this.totalAmount = new BigNumber(0)
                }
                this.totalComission = this.totalComission.toFixed(2)
                this.totalAmount = this.totalAmount.toFixed(2)
            }
            this.loadingTransfers = false
        },
    },
    mounted() {
        this.lazyParams = {
            first: 0,
            rows: 10,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)){
            const ref_id = route.params.id
            const partner = await this.connect.get_partner_by_id(ref_id).then(res=>res)
            if(partner.result) {
                this.partner = partner.data
            }
        }
    },
}
</script>

 

